import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Popover from "@material-ui/core/Popover/Popover";
import Box from "@material-ui/core/Box/Box";
import TextFieldsRoundedIcon from '@material-ui/icons/TextFieldsRounded';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {Translate} from "../../../../config/Translate";
class FontSizeButton extends React.Component {
    state = {
        anchorEl:null,
        font_size:null
    };
    classes = this.props.classes;

    handleChangeFont(font_size){
        this.setState({
            font_size,
            anchorEl:null,
        })
        this.props.handleFont(font_size);

    }
    handleClick = (event) => {
        this.setState({
            anchorEl: event.currentTarget
        })
    };
    handleClose = () => {
        this.setState({
            anchorEl: null
        })
    };
    render(){
        let {anchorEl,font_size} = this.state;
        const open = Boolean(anchorEl);
        return (
            <div>
                <Tooltip arrow title={Translate.changeFontSize}>
                    <IconButton
                        onClick={this.handleClick.bind(this)}
                        size="small"
                    >
                        <TextFieldsRoundedIcon  fontSize="small"/>
                    </IconButton>
                </Tooltip>

                <Popover
                    className={this.classes.fontSizePopOver}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => this.handleClose()}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Box p={2}>
                        <IconButton
                            size="small"
                            className={font_size === "75%" ? "active" : "deactive"}
                            onClick={() => this.handleChangeFont('75%')}
                        >
                            75%
                        </IconButton>
                        <IconButton
                            size="small"
                            className={font_size === "100%" ? "active" : "deactive"}
                            onClick={() => this.handleChangeFont('100%')}
                        >
                            100%
                        </IconButton>
                        <IconButton
                            size="small"
                            className={font_size === "125%" ? "active" : "deactive"}
                            onClick={() => this.handleChangeFont('125%')}
                        >
                            125%
                        </IconButton>
                        <IconButton
                            size="small"
                            className={font_size === "150%" ? "active" : "deactive"}
                            onClick={() => this.handleChangeFont('150%')}
                        >
                            150%
                        </IconButton>
                    </Box>
                </Popover>
            </div>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(FontSizeButton))));